import { environment } from "environments/environment";

class NameConfig {
    /**
     * Auto-detect gateway URL based on window.location.origin
     * Used when embedded mode is enabled
     */
    private static getGatewayUrl(): string {
        const origin = window.location.origin;
        if (origin.indexOf('127.0.0.1') > -1 || origin.indexOf('localhost') > -1 || origin.indexOf('xtalent-uat') > -1) {
            return 'https://xtalentgw-api-uat.a4b.vn/';
        }
        if (origin.indexOf('career-staging') > -1) {
            return 'https://xtalentgw-staging-api.vng.com.vn/';
        }
        if (origin.indexOf('career-prod') > -1 || origin.indexOf('career.vng.com.vn') > -1) {
            return 'https://xtalentgw-api.vng.com.vn/';
        }
        return 'https://xtalentgw-api.vng.com.vn/';
    }

    /**
     * Auto-detect XPlatform URL based on window.location.origin
     * Used when embedded mode is enabled
     */
    private static getXPlatformUrl(): string {
        const origin = window.location.origin;
        if (origin.indexOf('127.0.0.1') > -1 || origin.indexOf('localhost') > -1 || origin.indexOf('xtalent-uat') > -1) {
            return 'https://xplatform-api-uat.a4b.vn/';
        }
        if (origin.indexOf('career-staging') > -1) {
            return 'https://xplatform-staging-api.vng.com.vn/';
        }
        if (origin.indexOf('career-prod') > -1 || origin.indexOf('career.vng.com.vn') > -1) {
            return 'https://xplatform-api.vng.com.vn/';
        }
        return 'https://xplatform-api.vng.com.vn/';
    }

    public static get HOST_NAME(): string {
        // Use auto-detection for embedded mode, otherwise use window variables
        if (environment['isEmbedded']) {
            return this.getGatewayUrl();
        }
        return window['HOST_NAME_ICRM'];
    }

    public static get HOST_NAME_LOGIN(): string {
        if (environment['isEmbedded']) {
            return this.getGatewayUrl();
        }
        return window['HOST_NAME_LOGIN_ICRM'];
    }

    public static get PATH_SERVICE(): string {
        return this.HOST_NAME;
    }

    public static get PATH_SERVICE_LOGIN(): string {
        return this.HOST_NAME + 'api/';
    }

    public static get HOST_NAME_GW(): string {
        if (environment['isEmbedded']) {
            return this.getGatewayUrl();
        }
        return window['HOST_NAME_GW_ICRM'];
    }

    public static get PATH_SERVICE_GW(): string {
        return this.HOST_NAME_GW + 'api/';
    }

    public static get PATH_SERVICE_VNG_CLOUD(): string {
        // window['HOST_NAME_VNG_CLOUD'] = 'https://idms-gw.a4b.vn/';
        // window['HOST_NAME_VNG_CLOUD'] = 'http://idms-gw-uat.a4b.vn/';
        if (environment['isEmbedded']) {
            return this.getGatewayUrl();
        }
        return window['HOST_NAME_VNG_CLOUD'];
    }

    public static get XPLATFORM(): string {
        if (environment['isEmbedded']) {
            return this.getXPlatformUrl();
        }
        return window['HOST_NAME_XPLATFORM'];
    }
}

export const APP_CONFIG: { [key: string]: any } = {
    LIMIT_QUERY: 20,
    COMMAND_EXTRACT_CV_TIME_OUT: 60000,
    QUERY_TIME_OUT: 30000,
    COMMAND_TIME_OUT: 30000,
    DOWNLOAD_TIME_OUT: 120000,
    MAX_ELEMENT_IN_LIST: 1000,
    VERSION: environment.version,
    VERSION_HELP: '1.0',
    APP_CODE: 'HRM',
    APP_NAME_STORE: 'HRM',
    APP_NAME: 'HRM',
    TENANT: environment.tenant,
    COMPANY_CODE: 'A4B',
    COMPANY_NAME: 'A4B',
    ROW_HEIGHT_40: 40,
    ROW_HEIGHT_44: 44,
    ROW_HEIGHT_50: 50,
    HOST_NAME: NameConfig.PATH_SERVICE,
    HOST_NAME_LOGIN: NameConfig.PATH_SERVICE_LOGIN,
    HOST_NAME_GW: NameConfig.PATH_SERVICE_GW,
    HOST_NAME_VNG_CLOUD: NameConfig.PATH_SERVICE_VNG_CLOUD,
    KEY_JWT: 'Bearer ',
    SERVICE_REST: 'services/',
    LOGIN_SERVICE: 'authenticate',
    LOGOUT_SERVICE: 'j_spring_security_logout',
    LOGOUT: NameConfig.PATH_SERVICE_LOGIN + 'logout',
    GET_MENU_TREE: 'menuByModule?module=home',
    GET_USERINFO: 'profileInfo',
    CHECK_LOGIN: 'identityServiceWrapper/checkLoggedIn',
    INPUT_TEXT_DEBOUNCE_TIME: 400,
    SCROLL_DEBOUNCE_TIME: 400,
    LANGUAGES: [{
        name: 'English', code: 'en', locale: 'en-US',
    }],
    LANGUAGE_LOCALE: {
        'en': 'en-US'
    },
    DEFAULT_LANGUAGE: 'en',
    ITEMS_PER_PAGE: [20, 50, 100, 200],
    ITEMS_FOR_SELECTION: 20,
    LANGUAGE_WEB: 'LANGUAGE_WEB',
    IMAGE_LOGO: 'assets/images/logo/logo.png',
    I18N_SERVICE: NameConfig.HOST_NAME + 'i18n/services/',
    MCRCUSTOMER_SERVICE: NameConfig.HOST_NAME + 'mcrcustomer/services/',
    EXCEL_API: NameConfig.HOST_NAME + 'mcrcustomer/api/excel/',
    MCRFORMIO_SERVICE: NameConfig.HOST_NAME + 'mcrformio/services/',
    DMS_SERVICE: NameConfig.HOST_NAME + 'dms/services/',
    DMS_RESOURCE: NameConfig.HOST_NAME + 'dms/',
    MCRNOTIFICATION: NameConfig.HOST_NAME + 'services/mcrnotification/',
    MCRMULTINOTIFICATIONS: NameConfig.HOST_NAME + 'mcrnotification/services/messageServices/',
    MCRTICKET_SERVICE: NameConfig.HOST_NAME + 'mcrticket/services/',
    MCRTICKET_API: NameConfig.HOST_NAME + 'services/mcrticket/api/',
    MCRTICKET_RPT_API: NameConfig.HOST_NAME + 'mcrticketrpt/api/',
    MCRTICKET_EXCEL_API: NameConfig.HOST_NAME + 'mcrticket/api/excel/',
    SECMT_API_SERVICE: NameConfig.HOST_NAME + 'mcrsecmt/services/',
    MCRSECMT_API: NameConfig.HOST_NAME + 'mcrsecmt/api/',
    MCRSUPPORTER: NameConfig.HOST_NAME + 'mcrsupporter/services/',
    CRM_TICKET: NameConfig.HOST_NAME + 'crmticket/',
    MCRUS_PROFILE: NameConfig.HOST_NAME + 'mcrusprofile/services/',
    MCRUS_PROFILE_API: NameConfig.HOST_NAME + 'services/mcrusprofile/api/',
    MCR_DMS: NameConfig.HOST_NAME + 'services/mcrowldms/api/',
    ACTIVITY_APP: NameConfig.HOST_NAME + 'activitystreams/services/',
    ACTIVITY_APP_API: NameConfig.HOST_NAME + 'services/activitystreams/api/',
    SOCMS: NameConfig.HOST_NAME + 'socms/services/',
    MCRBILLING: NameConfig.HOST_NAME + 'mcrbilling/services/',
    CRMRPT_SERVICE: NameConfig.HOST_NAME + 'mcr-crmrpt/api/ca/',
    CRMRPT_SC_SERVICE: NameConfig.HOST_NAME + 'mcr-crmrpt/api/sc/',
    MCR_CLOUD: NameConfig.HOST_NAME + 'mcrcloud/services/',
    MCR_FLEX_OFFICE: NameConfig.HOST_NAME + 'mcrflexoffice/api/',
    MCR_EVENT: NameConfig.HOST_NAME + 'mcrevent/services/',
    MCRCRMRPT: NameConfig.HOST_NAME + 'services/mcrcrmrpt/',
    MCRFEA: NameConfig.HOST_NAME + 'mcrfea/services/',
    MCRJOB: NameConfig.HOST_NAME + 'mcrjob/api/',
    MCRISGCUS: NameConfig.HOST_NAME + 'services/mcrisgcus/api/',
    MCREVL: NameConfig.HOST_NAME + 'services/mcrevl/api/',
    MCR_US_PROFILE: NameConfig.HOST_NAME + 'services/mcrusprofile/api/',
    MCR_IPT: NameConfig.HOST_NAME + 'services/mcript/api/',
    MCR_EVL_RU: NameConfig.HOST_NAME + 'services/mcrevlru/api/',
    MCR_SIG: NameConfig.HOST_NAME + 'services/mcrsig/api/',
    MCR_SECMT_API: NameConfig.HOST_NAME + 'services/mcrsecmt/api/',
    MCRUS_PROFILE_PUB: NameConfig.HOST_NAME + 'services/mcrusprofile/pub/',
    MCR_ISG_DBRP: NameConfig.HOST_NAME + 'services/mcrisgdbrp/api/dashboard/',
    MCR_ISG_JOB: NameConfig.HOST_NAME + 'services/mcrisgjob/api/job/',
    MCR_ISG_DBRP_SERVICE: NameConfig.HOST_NAME + 'services/mcrisgdbrp/api/',
    MCR_BULK_UPLOAD: NameConfig.HOST_NAME + 'services/mcrowlbulkup/api/',
    MCR_KALAPA: NameConfig.HOST_NAME + 'services/mcrkalapa/api/',
    MCR_CONTRACT: NameConfig.HOST_NAME + 'services/mcrcontract/api/',
    MCR_CUSTOMER: NameConfig.HOST_NAME + 'services/mcrcustomer/api/',
    MCR_JOB_SERVICE: NameConfig.HOST_NAME + 'services/mcrjob/api/job/',
    MCRHRDMS: NameConfig.HOST_NAME + 'services/mcrhrdms/api/',
    MCR_ATICK: NameConfig.HOST_NAME + 'services/mcratick/api/',
    MCRGCL: NameConfig.HOST_NAME + 'services/mcrgcl/api/',
    XFLOW_ENGINE: NameConfig.HOST_NAME + 'services/xflow-engine/api/',
    XPTASK: NameConfig.HOST_NAME + 'services/xptask/api/',
    XPACTSTREAMS: NameConfig.HOST_NAME + 'services/xpactstreams/api/',
    MCRHRC: NameConfig.HOST_NAME + 'services/mcrhrc/api/',
    MCRHRRCRT: NameConfig.HOST_NAME + 'services/mcrhrrcrt/api/',
    XPSECMT: NameConfig.HOST_NAME + 'services/xpsecmt/api/',
    XPBOLDBI: NameConfig.HOST_NAME + 'services/xpboldbi/api/',
    XFAI: NameConfig.HOST_NAME + 'services/xfai/api/',
    XPSNS: NameConfig.HOST_NAME + 'services/xpsns/api/',
    XPLATFORM: NameConfig.XPLATFORM,
    XPBATCH: NameConfig.HOST_NAME + 'services/xpbatch/api/',
};
export const API_URL: any = {
    ATTRIBUTE: {
        // GET: APP_CONFIG.HOST_NAME_LOGIN + 'getAttributeValueOfUser',
        // SET: APP_CONFIG.HOST_NAME_LOGIN + 'setAttributeValueForUser',
        GET: APP_CONFIG.XPSECMT + 'attribute/getAttributeValueOfUser',
        SET: APP_CONFIG.XPSECMT + 'attribute/setAttributeValueForUser',
    },
    USER_JOB: {
        SEARCH_USER_JOBS: APP_CONFIG.MCRJOB + 'job/searchUserJobs',
        PIVOT_COUNT: APP_CONFIG.MCRJOB + 'job/pivotCount',
    },
    ENVELOPS: {
        QUICK_SEARCH_CONTACT: APP_CONFIG.MCRISGCUS + 'contact/quickSearch',
        GET_ENVELOPE_CATEGORY: APP_CONFIG.MCREVL + 'category/listEnvelopeCategory',
        GET_FIELD_TYPE: APP_CONFIG.MCREVL + 'category/listFieldType',
        GET_VERIFICATION: APP_CONFIG.MCREVL + 'category/listVerification',
        GET_SIGNATURE_TYPE: APP_CONFIG.MCREVL + 'category/listSignatureType',
        GET_AUTHORIZATION: APP_CONFIG.MCREVL + 'category/listAuthorization',
        GET_AUTHENTICATION: APP_CONFIG.MCREVL + 'category/listAuthentication',
        GET_ORDER_TYPE: APP_CONFIG.MCREVL + 'category/listOrderType',
        GET_CURRENT_USER_TENANTS: APP_CONFIG.MCR_US_PROFILE + 'employee/getCurrentUserTenants',
        CHANGE_TENANT: NameConfig.HOST_NAME + 'api/auth/changeTenant'
    }
}
export class LOGIN_URL {
    static LOGIN: string = APP_CONFIG.HOST_NAME_LOGIN + 'authenticate';
    static MENU: string = APP_CONFIG.XPSECMT + 'permission/getMenuTreeByModule?module=recruitment';
    static USER_INFO: string = APP_CONFIG.HOST_NAME_LOGIN + 'profileInfo';
    static LOG_OUT: string = APP_CONFIG.HOST_NAME_LOGIN + 'logout';
    static GET_TOKEN: string = APP_CONFIG.HOST_NAME_GW + 'authenticateWithToken';
    static GET_PROFILE_NEW: string = APP_CONFIG.HOST_NAME_GW + 'profileInfo';
    static GET_HASURA_TOKEN: string = APP_CONFIG.HOST_NAME_GW + 'hasura/issue';
}
